<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="SP"> </p>
<p class="FM-Epigraph-non-verse-fmepi"><span epub:type="pagebreak" id="pg_ix" title="ix"><span class="ePub-I">I learned this, at least, by my experiment:</span></span></p>
<p class="FM-Epigraph-non-verse-fmepi"><span class="ePub-I">that if one advances confidently in the direction of his dreams,</span></p>
<p class="FM-Epigraph-non-verse-fmepi"><span class="ePub-I">and endeavors to live the life which he has imagined,</span></p>
<p class="FM-Epigraph-non-verse-fmepi"><span class="ePub-I">he will meet with a success unexpected in common hours.</span></p>
<p class="FM-Epigraph-Source-fmeps">—Henry David Thoreau</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?675533b3